__turbopack_context__.v({
  "cta": "box-cta-module__S6R8rW__cta",
  "destructive": "box-cta-module__S6R8rW__destructive",
  "large": "box-cta-module__S6R8rW__large",
  "loading": "box-cta-module__S6R8rW__loading",
  "medium": "box-cta-module__S6R8rW__medium",
  "neutral-filled": "box-cta-module__S6R8rW__neutral-filled",
  "neutral-outline": "box-cta-module__S6R8rW__neutral-outline",
  "neutral-tonal": "box-cta-module__S6R8rW__neutral-tonal",
  "primary": "box-cta-module__S6R8rW__primary",
  "slot": "box-cta-module__S6R8rW__slot",
  "small": "box-cta-module__S6R8rW__small",
  "text": "box-cta-module__S6R8rW__text",
  "wide": "box-cta-module__S6R8rW__wide",
});
